import React, { FC } from 'react'
import { Button } from '../Button/Button'
import { BackIcon } from '../Icons/BackIcon/BackIcon'
import { t } from '@lingui/macro'
import { Stepper } from '../Stepper/Stepper'

import styles from './Header.module.scss'

interface HeaderProps {
  skip?: () => void
  back?: () => void
  steps?: number
  currentStep?: number
}

export const Header: FC<HeaderProps> = ({
  skip,
  back,
  steps,
  currentStep = 1
}) => {
  return (
    <div className={styles.Container}>
      {/* Back */}
      {back && (
        <Button
          icon={<BackIcon />}
          iconOnly
          variant="text"
          theme="primary"
          aria-label="Go back"
          onClick={back}
        />
      )}

      {/* Stepper */}
      {steps && <Stepper steps={steps} currentStep={currentStep} />}

      {/* Skip */}
      <div className={styles.skipWrapper}>
        {skip && (
          <Button
            className='Inline'
            variant="text"
            theme="support"
            onClick={skip}
            label={t`Skip`}
          />
        )}
      </div>
    </div>
  )
}
